/* eslint-disable max-len */
/* eslint-disable react/display-name */
import React, { useCallback, useState } from 'react';
import { LFC } from '../../../Legacy';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Icon } from '../../../concepts/resources/Icon';
import { DropButton } from '../../../ui/DropButton';
import { useResolve } from '../../Container';
import { Copy, Flexer } from '../../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../../popups/Popup';
import { PopupManager } from '../../popups/PopupManager';
import { jiraImport } from '../atlassian/AtlassianCommands';
import { createGraphicFromPopup } from '../graphics/GraphicCommands';
import { Prompt } from './../../../ui';
import { importDataFromCsvFile } from './ImportDataFromCsvFilePopup';

export const importData = defineCommand(
    'importData',
    'Import: Data',
    async r => {
        await r.call(PopupManager).invoke(importDataPopup());
    }
);

type OptionProps = {
    icon: string,
    label: string,
    desc: string,
    onAction: () => void,
};

const Option = ({ icon, label, desc, onAction }: OptionProps) => {
    const [active, setActive] = useState(false);
    return <DropButton role="button" aria-label={label} active={active} onClick={onAction}>
        <Flexer grow flex="row" gap="1" padding=".5">
            <Flexer flex="row" center shrink>
                <Icon src={icon} size="3" />
            </Flexer>
            <Flexer flex="column" gap=".25">
                <Flexer flex="row" align="center" justify="space-between">
                    <Copy bold flush size="1.25">{label}</Copy>
                </Flexer>
                <Copy flush size=".875">{desc}</Copy>
            </Flexer>
        </Flexer>
    </DropButton>;
};

export const importDataPopup = () => ({ ui: ImportDataPopup });

export const ImportDataPopup: LFC<PopupProps> = ({ action, dismiss, args }) => {

    const dispatch = useResolve(CommandDispatcher);
    const onCancel = useCallback(() => dismiss(), [dismiss]);

    const onFile = () => dispatch(importDataFromCsvFile);
    const onImage = () => dispatch(createGraphicFromPopup);
    const onJira = () => dispatch(jiraImport);

    return <Prompt ignoreEnter onAction={onCancel}>
        <Popup w={32}>
            <Popup.Close onAction={onCancel} />
            <Popup.Header>
                <Popup.Title>Import Data</Popup.Title>
                <Popup.SubTitle>Create objects from data</Popup.SubTitle>
            </Popup.Header>
            <Flexer height="1" />
            <Flexer flex="column" gap=".5">
                <Option
                    label="CSV File"
                    desc="Import CSV data and convert to stickies or cards."
                    icon="deqo://icons/i8/color-csv"
                    onAction={onFile}
                />
                <Option
                    label="Image File"
                    desc="Import an image and insert into your board."
                    icon="deqo://icons/i8/color-image"
                    onAction={onImage}
                />
                <Option
                    label="From Jira"
                    desc="Pull tickets from Jira directly into your board."
                    icon="deqo://icons/i8/color-jira"
                    onAction={onJira}
                />
            </Flexer>
            <Flexer height=".5" />
        </Popup>
    </Prompt>;
};
